export enum EventSegmentationType {
  AllStudents = 'Todos los alumnos',
  RegisteredStudentsOnly = 'Todos los alumnos matriculados en:'
}